import { LIMIT } from '@/constants';
import { fetchWaitCommentList, fetchYetCommentList } from '@/services';
import { CommentState, LoadMoreStatus, type AnyObj } from '@/types';
import type { ShoppingTrolley } from '@/types/global-business';
import { defineStore } from 'pinia';

interface State {
  /** 评论列表 */
  commentList: AnyObj[];
  /** 评论列表请求选项 */
  options: { skip: number };
  /** 列表加载状态 */
  loadStatus: LoadMoreStatus;
  /** 评论下标状态 */
  commentStateIndex: CommentState;
  /** 评论提交数据项 */
  commentControl: {
    productId: string;
    orderId: string;
    orderLineId: string;
    commodity: ShoppingTrolley.Commodity;
    description: string;
    reviewImgs: string[];
    customerNameIsPublic: boolean;
    stars: number;
  };
}

export const useCommentStore = defineStore('comment', {
  state: (): State => ({
    commentList: [],
    options: {
      skip: 0,
    },
    loadStatus: LoadMoreStatus.loading,
    commentStateIndex: CommentState.wait,
    commentControl: {
      productId: '',
      orderId: '',
      orderLineId: '',
      description: '',
      commoditys: null,
      reviewImgs: [],
      customerNameIsPublic: false,
      stars: 5,
    },
  }),

  getters: {},

  actions: {
    async getWaitCommentList(skip: number = 0, refresh?: boolean) {
      const res = await fetchWaitCommentList(skip);
      if (res) {
        if (res.length < LIMIT) {
          this.loadStatus = LoadMoreStatus.noMore;
        } else {
          this.loadStatus = LoadMoreStatus.more;
        }

        if (refresh) {
          this.commentList = [...res];
        } else {
          this.commentList = [...this.commentList, ...res];
        }
      }
      return this.commentList;
    },
    async getYetCommentList(skip: number = 0, refresh?: boolean) {
      const res = await fetchYetCommentList(skip);
      if (res) {
        if (res.length < LIMIT) {
          this.loadStatus = LoadMoreStatus.noMore;
        } else {
          this.loadStatus = LoadMoreStatus.more;
        }

        if (refresh) {
          this.commentList = [...res];
        } else {
          this.commentList = [...this.commentList, ...res];
        }
      }
      return this.commentList;
    },
    resetCommentSubmit() {
      this.commentControl = {
        productId: '',
        orderId: '',
        orderLineId: '',
        description: '',
        commoditys: null,
        reviewImgs: [],
        customerNameIsPublic: false,
        stars: 5,
      };
    },
  },
});
